// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.

/**
 * This package is used to manage persistent, per-user cached credentials.
 *
 * @packageDocumentation
 */

export {
  CredentialCache,
  type ICredentialCacheEntry,
  type ICredentialCacheOptions,
  RUSH_USER_FOLDER_NAME
} from './CredentialCache';
